export default function generateQuestionForm(player) {
    const localize = player.localize?.bind(player);
    const template = `<h2 class="ask-a-question-header">${localize('Ask a Question')}</h2>
<form>
    <p><label>* ${localize('Name')}<br><input name="name" required /></label></p>
    <p><label>${localize('Email')}<br><input type="email" name="email" /></label></p>
    <p><label>* ${localize('Subject')}<br><input name="subject" maxlength="' + o.subject.maxLength + '" required /></label></p>
    <p><label>* ${localize('Message')}<br><textarea name="message" rows="8" cols="30" required></textarea></label></p>
    <p><fieldset class="time-fieldset"><legend class="vjs-hidden">${localize('Time')}</legend><input type="checkbox" name="timeCheckbox" aria-label="${localize('Enable Time')}"/><span>${localize('Time at')}</span><input name="time" pattern="^\\d\\d:[0-5]\\d:[0-5]\\d$" aria-label="${localize('Time')}" /></fieldset></p>
    <p><small>* ${localize('Required Field')}</small></p>
    <p class="text-align-center"><input class="question-submit-button player-primary-button" type="submit" value="${localize('Submit')}" /></p>
</form>`;

    const container = document.createElement('div');
    container.innerHTML = template;
    return container;
}